import { PrivateRoute } from "@router/private-route";
import { RouteObject } from "react-router-dom";

import { AdministrationLayout } from "./administration.layout";
import { AdministrationPage } from "./pages";
import { AdministrationCompaniesPage } from "./pages/companies";
import { AdministrationUserPage } from "./pages/users";

const ROUTER_ADMINISTRATION = {
  INDEX: "/administration",
  USERS_INDEX: "users",
  COMPANIES_INDEX: "companies",
};

export const administrationRouter: RouteObject = {
  path: ROUTER_ADMINISTRATION.INDEX,
  Component: AdministrationLayout,
  children: [
    { index: true, element: <PrivateRoute element={<AdministrationPage />} /> },
    { path: ROUTER_ADMINISTRATION.USERS_INDEX, element: <PrivateRoute element={<AdministrationUserPage />} /> },
    { path: ROUTER_ADMINISTRATION.COMPANIES_INDEX, element: <PrivateRoute element={<AdministrationCompaniesPage />} /> },
  ],
};
